import { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { setIsLoading } from "../../reduxSetup/action";
import Statistic from "../../components/Statistic/Statistic";

const MySpots = ({ setIsLoading, email, user }) => {
  const [spots, setSpots] = useState(null);

  return (
    <div>
      <Statistic data={spots} />
    </div>
  );
};

MySpots.propTypes = {
  setIsLoading: PropTypes.func,
  email: PropTypes.string,
};

const mapDispatchToProps = {
  setIsLoading,
};

const mapStateToProps = ({ user: { email } }) => {
  return {
    email,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MySpots);
